module.exports = __webpack_public_path__ + "static/media/icon-back.1570235a.svg";